// This is for the production site, which is hosted at https://angular.io
export const environment = {
  gaId: 'UA-8594346-28', // Production id
  production: true,
  mode: 'stable'
};
